import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Styled `<input>` primitive — shadcn/ui convention on the existing token stack.
 *
 * Visual language mirrors the bespoke inputs throughout the app:
 *   - `border-crucible-border bg-transparent` base
 *   - `focus:border-crucible-accent` ring (no outline flash)
 *   - `text-crucible-fg` / `placeholder:text-crucible-muted`
 *   - `rounded-[var(--radius-md)]` (8 px, consistent with other primitives)
 *
 * `app-region-no-drag` is required on every interactive element so the
 * Electron window-drag region does not eat clicks (#531 / #804).
 */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'app-region-no-drag w-full rounded-[var(--radius-md)] border border-crucible-border',
          'bg-transparent px-3 py-2 text-sm text-crucible-fg',
          'placeholder:text-crucible-muted',
          'transition-colors focus:border-crucible-accent focus:outline-none',
          'disabled:cursor-not-allowed disabled:opacity-40',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
